var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDeleteFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00033 0.667969C4.39199 0.667969 0.666992 4.39297 0.666992 9.0013C0.666992 13.6096 4.39199 17.3346 9.00033 17.3346C13.6087 17.3346 17.3337 13.6096 17.3337 9.0013C17.3337 4.39297 13.6087 0.667969 9.00033 0.667969ZM13.167 11.993L11.992 13.168L9.00033 10.1763L6.00866 13.168L4.83366 11.993L7.82533 9.0013L4.83366 6.00964L6.00866 4.83464L9.00033 7.8263L11.992 4.83464L13.167 6.00964L10.1753 9.0013L13.167 11.993Z",
    fill: "#B50E37"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDeleteFile);
export default __webpack_public_path__ + "static/media/IconDeleteFile.08bec686805b06b4994bd3d2535c6e0f.svg";
export { ForwardRef as ReactComponent };